import { Redirect } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { userAtom } from '@/atoms/_globalAtoms'
import { isSuperAdmin } from '@/hooks/utility/useIsSuperAdmin'
import { Navigation } from 'components'
import { ADMIN_PAGE_GROUPS } from '../adminPages'
import { AdminHomeCard } from './AdminHomeCard'
import {
  CardGrid,
  Group,
  GroupHeading,
  Header,
  PageWrap,
  Subtitle,
  Title,
} from './AdminHome.styled'

/**
 * The admin home at /admin: every listed admin tool as a card under its
 * group. It shows to super admins and sends anyone else whose user record
 * loads to /dashboard. It waits for the record first, because on a hard
 * reload the record loads after the first render and a super admin would
 * otherwise be redirected; a session whose record never loads sees an empty
 * page.
 */
export const AdminHome = () => {
  const user = useRecoilValue(userAtom)

  if (user === null) return null
  if (!isSuperAdmin(user)) return <Redirect to="/dashboard" />

  return (
    <>
      <Navigation type="admin" />
      <PageWrap data-testid="admin-home">
        <Header>
          <Title>MDL Admin</Title>
          <Subtitle>The admin tools, grouped by what they work on.</Subtitle>
        </Header>
        {ADMIN_PAGE_GROUPS.map((group) => (
          <Group key={group.label} aria-labelledby={headingId(group.label)}>
            <GroupHeading
              id={headingId(group.label)}
              data-testid="admin-home-group-heading"
            >
              {group.label}
            </GroupHeading>
            <CardGrid>
              {group.pages.map((page) => (
                <AdminHomeCard key={page.path} page={page} />
              ))}
            </CardGrid>
          </Group>
        ))}
      </PageWrap>
    </>
  )
}

const headingId = (groupLabel: string) =>
  `admin-home-group-${groupLabel.toLowerCase().replace(/\s+/g, '-')}`
